<template>
  <!-- TODO: add  nav-toc__heading class -->
  <button
    :aria-expanded="isExpanded ? 'true' : 'false'"
    class="nav-toc__toggle styled-button"
    :class="{
      'nav-toc__toggle--is-expanded': internalIsExpanded,
      'nav-toc__toggle--no-text': !hasButtonText,
      'nav-toc__toggle--has-heading': hasHeadingSize,
      'is-closing': isClosing,
    }"
    @click="toggle"
  >
    <div>
      <span
        class="nav-toc__icon"
        :class="{
          'nav-toc__icon--close': isExpanded,
          'nav-toc__icon--open': !isExpanded,
        }"
      >
        <a-label :path="isExpanded ? 'dossier.close' : 'dossier.open'" />
      </span>
    </div>
    <strong
      v-if="hasButtonText"
      id="nav-toc"
      class="nav-toc__toggle-text"
      :class="{
        'nav-toc__heading': hasHeadingSize,
      }"
      >{{ buttonText }}</strong
    >
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  inject: ['navTocContext', 'context', 'toggle', 'registerToggleEl'],
  data() {
    return {
      internalIsExpanded: false,
      isClosing: false,
      hasHeading: false,
    };
  },
  computed: {
    ...mapGetters({
      breakpointUp: 'window/breakpointUp',
    }),
    isExpanded() {
      return this.context.isExpanded;
    },
    hasButtonText() {
      // Determines if button text should be shown
      console.log('Debug hasButtonText:', {
        hasHeading: this.navTocContext.hasHeading,
        buttonText: this.navTocContext.buttonText,
        result:
          !this.navTocContext.hasHeading &&
          Boolean(this.navTocContext.buttonText),
      });
      return (
        !this.navTocContext.hasHeading && Boolean(this.navTocContext.buttonText)
      );
    },
    buttonText() {
      // Returns the actual button text
      return this.navTocContext.buttonText || '';
    },
    hasHeadingSize() {
      return this.navTocContext.hasHeadingSize;
    },
  },
  watch: {
    isExpanded(isExpanded) {
      if (isExpanded) {
        this.internalIsExpanded = true;
        this.isClosing = false;
        return;
      }

      // Set closing flag immediately
      this.isClosing = true;

      // Remove expanded class after transition
      setTimeout(() => {
        this.internalIsExpanded = false;
        this.isClosing = false;
      }, 400);
    },
  },
  mounted() {
    this.registerToggleEl(this.$el);
  },
  methods: {
    scrollIntoView() {
      if (this.breakpointUp('sm')) return;
      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    },
  },
};
</script>
